export const orderCashoutButtonTextSetMinAmount = 'order_cashout_button_text_set_min_amount';
export const orderCashoutButtonTextSetMaxAmount = 'order_cashout_button_text_set_max_amount';
